import { inject } from '@angular/core';
import { Routes } from '@angular/router';
import { ROUTE } from '@lib/core/const';
import { PERMISSION } from '@lib/core/enum';
import { PermissionGuard } from '@lib/core/guard';
import { PermissionService } from '@lib/core/permission';
import { LogListComponent, LogRepository as DefaultLogRepository } from '@lib/log';
import { map, Observable } from 'rxjs';

import { MyCardComponent } from './container/my-card/my-card.component';
import { AttributesComponent } from './container/tabs/attributes/attributes.component';
import { BackupsComponent } from './container/tabs/backups/backups.component';
import { CertificatesComponent } from './container/tabs/certificates/certificates.component';
import { DevicesComponent } from './container/tabs/devices/devices.component';
import { GraphComponent } from './container/tabs/graph/graph.component';
import { SettingsComponent } from './container/tabs/settings/settings.component';
import { ViewComponent } from './container/view/view.component';
import { UserLogRepository } from './repository';
import { MyCardResolve } from './resolve/my-card-resolve.const';
import { UserResolve } from './resolve/user-resolve.const';

export const USER_CARD_ROUTES: Routes = [
  {
    path: '',
    component: MyCardComponent,
    canMatch: [(): Observable<boolean> => inject(PermissionService).hasPermission(PERMISSION.USER_CARD_ALLOW_VIEW)
      .pipe(map((hasPermission) => !hasPermission)),
    ],
    data: {
      breadcrumbResolveTitle: 'user',
    },
    resolve: {
      user: MyCardResolve,
    },
  },
  {
    path: '',
    component: ViewComponent,
    canMatch: [(): Observable<boolean> => inject(PermissionService).hasPermission(PERMISSION.USER_CARD_ALLOW_VIEW)],
    data: {
      breadcrumbResolveTitle: 'user',
    },
    resolve: {
      user: UserResolve,
    },
    children: [
      {
        path: ROUTE.USER.TAB.DEVICES,
        title: 'library.user_card.tab.devices',
        canActivate: [PermissionGuard],
        component: DevicesComponent,
        data: {
          permission: PERMISSION.USER_CARD_ALLOW_VIEW,
        },
      },
      {
        path: ROUTE.USER.TAB.ATTRIBUTES,
        title: 'library.user_card.tab.attributes',
        canActivate: [PermissionGuard],
        component: AttributesComponent,
        data: {
          permission: PERMISSION.USER_CARD_ALLOW_VIEW,
        },
      },
      {
        path: ROUTE.USER.TAB.CERTIFICATES,
        title: 'library.user_card.tab.certificates',
        canActivate: [PermissionGuard],
        component: CertificatesComponent,
        data: {
          permission: PERMISSION.USER_CARD_ALLOW_VIEW,
        },
      },
      {
        path: ROUTE.USER.TAB.AUDIT_LOGS,
        title: 'library.user_card.tab.audit_logs',
        canActivate: [PermissionGuard],
        component: LogListComponent,
        data: {
          permission: PERMISSION.USER_CARD_ALLOW_VIEW,
          listName: 'user-logs',
        },
        providers: [
          {
            provide: DefaultLogRepository,
            useClass: UserLogRepository,
          },
        ],
      },
      {
        path: ROUTE.USER.TAB.BACKUPS,
        title: 'library.user_card.tab.backups',
        canActivate: [PermissionGuard],
        component: BackupsComponent,
        data: {
          permission: PERMISSION.USER_CARD_ALLOW_VIEW,
        },
      },
      {
        path: ROUTE.USER.TAB.SETTINGS,
        title: 'library.user_card.tab.settings',
        canActivate: [PermissionGuard],
        component: SettingsComponent,
        data: {
          permission: PERMISSION.USER_CARD_ALLOW_VIEW,
        },
      },
      {
        path: ROUTE.USER.TAB.GRAPH,
        title: 'graph.title',
        canActivate: [PermissionGuard],
        component: GraphComponent,
        data: {
          permission: PERMISSION.SUPER_ADMIN,
        },
      },
    ],
  },
];
